import React from "react";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import moment from "moment";


const PageFooter = (props) => {

    const company = (process.env.REACT_APP_COPYRIGHT || (props.company ? props.company : "Magma Aviation"))+" "+ moment().format("YYYY");

    let theme = useTheme();

    const classes = makeStyles({
        pageMargins: {
            marginLeft: "40px",
            marginRight: "40px",
            [theme.breakpoints.down('md')]: {
                marginLeft: "5px",
                marginRight: "5px"
            }
        },
        section: {
            float: "left",
            width: "20%",
            height: "100%",
            padding: 0,
        }
    })();

    return (
        <div>
            <div style={{ height: 10 }}></div>
            <div
                style={{
                    marginLeft: 40,
                    marginRight: 40,
                    height: 2,
                    backgroundColor: "#b7c3d4",
                }}
            ></div>
            <div className={classes.pageMargins +" clearfix"} style={{ backgroundColor:theme.palette.background.default}}>
                <div style={{height: 45}}>
                    <div className={classes.section}>
                        <div style={{float:"left", width:"100%", padding:15, margin:0, color: "#000000", display:"block", fontWeight: 400, fontSize: 14, fontFamily:"Ubuntu,sans-serif", textDecoration: "none"}}>&copy; {company}</div>
                    </div>
                    <div className={classes.section}></div>
                    <div className={classes.section}></div>
                    <div className={classes.section}></div>
                    <div className={classes.section}>
                        <div style={{padding:10, margin:0}}>
                            {process.env.REACT_APP_POWERED_BY && <a rel="noreferrer" href="https://4wardmomentum.com" target="_blank"><img src="images/PoweredByFM.png" style={{maxHeight:26}} alt="powered by" /></a>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PageFooter;